/* eslint-disable no-unused-vars */
import React from 'react'
import { InsightsH1, H3, H4, BodyCopy } from '../Globals'
import SocialMedia from '../SocialMedia'
import {
  generateRandomKey,
  parseHTMLSpecialChars,
  formatDate,
  getCustomEyebrowLink,
} from '@utils'
import Html from '../Html'
import { StyledA } from './style'
import A from '@components/A'

const renderAuthor = ({ authors, bylineHtml, associatedProfessionals }) => {
  let finalAuthor = [{ name: 'Paul Hastings Professional' }]
  if (
    bylineHtml &&
    bylineHtml.useHTMLField &&
    bylineHtml.useHTMLField === 'true' &&
    bylineHtml.html &&
    bylineHtml.html !== ''
  ) {
    finalAuthor = bylineHtml
  } else if (authors?.length > 0) {
    finalAuthor = authors
  } else if (associatedProfessionals?.length > 0) {
    finalAuthor = associatedProfessionals
  }
  return finalAuthor
}

const ArticleDate = ({ date }) => {
  return (
    <BodyCopy fontSize={16} marginTop={30}>
      {formatDate(date)}
    </BodyCopy>
  )
}
const ArticleByline = ({ authors = [] }) => {
  let renderAuthors = <></>
  if (
    authors &&
    typeof authors === 'object' &&
    authors.useHTMLField &&
    authors.useHTMLField === 'true' &&
    authors.html
  ) {
    // show raw HTML
    const sanitizedAuthors = { ...authors }
    return (
      <H4 marginBottom={35} fontSize="16px" color="gold" normalCase>
        <Html contentHtml={sanitizedAuthors} inline />
      </H4>
    )
  } else if (
    authors &&
    typeof authors === 'object' &&
    authors[0] &&
    authors[0].name !== 'Paul Hastings Professional'
  ) {
    return (
      <H4 marginBottom={35} fontSize="16px" color="gold" normalCase>
        <span style={{ textTransform: 'none', color: 'black' }}>{'By '}</span>
        {authors.map(({ active, slug, name }, i) =>
          active ? (
            <StyledA
              key={generateRandomKey()}
              to={slug}
              contentType="ContentfulProfessional"
              mr="4px"
            >
              {i === authors.length - 1 && authors.length > 1 ? 'and ' : ''}
              {name}
              {i === authors.length - 1
                ? ''
                : i === authors.length - 2
                ? ''
                : ','}
            </StyledA>
          ) : (
            <BodyCopy
              key={generateRandomKey()}
              style={{ display: 'inline-block', fontSize: '16px' }}
              mr="4px"
            >
              {i === authors.length - 1 && authors.length > 1 ? 'and ' : ''}
              {name}
              {i === authors.length - 1
                ? ''
                : i === authors.length - 2
                ? ''
                : ','}
            </BodyCopy>
          )
        )}
      </H4>
    )
  } else {
    if (
      authors &&
      authors[0] &&
      authors[0].name &&
      authors[0].name === 'Paul Hastings Professional'
    ) {
      return (
        <H4 marginBottom={35} fontSize="16px" color="gold" normalCase>
          By Paul Hastings Professional
        </H4>
      )
    }
  }

  return (
    <H4 marginBottom={35} fontSize="16px" color="gold" normalCase>
      {renderAuthors}
    </H4>
  )
}
const ArticleDetails = ({
  date,
  authors,
  pageSlugs,
  category,
  contentType,
  useByline = true,
}) => {
  const isEvent = contentType === 'ContentfulEvent' || category === 'event'
  const isArticle =
    contentType === 'ContentfulArticle' || contentType === 'article'
  const renderByline = useByline !== false

  return (
    <>
      {date && !isEvent && <ArticleDate date={date} />}
      {isArticle && category !== 'Accolades' && renderByline && (
        <ArticleByline authors={authors} pageSlugs={pageSlugs} />
      )}
    </>
  )
}

const renderEyebrow = (props, categoryData, isNewsOrEvent, contentType) => {
  const shouldShowCustomEyebrow =
    props?.category?.title === 'Practice Area Articles' &&
    props?.showCustomEyebrow === true &&
    props?.customEyebrow

  if (!shouldShowCustomEyebrow) {
    // default category rendering
    if (categoryData.slug) {
      return isNewsOrEvent ? (
        categoryData.title.replace(/-/g, ' ')
      ) : (
        <A to={categoryData.slug} contentType={contentType}>
          {categoryData.title.replace(/-/g, ' ')}
        </A>
      )
    }
    return categoryData.title.replace(/-/g, ' ')
  }

  // custom eyebrow rendering
  const customLink = getCustomEyebrowLink(props)
  if (customLink) {
    return (
      <A
        to={customLink.slug}
        category={customLink?.category?.slug}
        contentType={customLink.__typename}
      >
        {props.customEyebrow}
      </A>
    )
  }

  // custom Eyebrow link Fallback (display custom eyebrow but fall back to category link)
  if (categoryData.slug && !isNewsOrEvent) {
    return (
      <A to={categoryData.slug} contentType={contentType}>
        {props.customEyebrow}
      </A>
    )
  }

  return props.customEyebrow
}

const ArticleHeader = props => {
  let title = props?.title
  const contentType = props?.__typename
  const isNewsOrEvent =
    contentType === 'ContentfulNews' || contentType === 'ContentfulEvent'
  const categoryData = {
    title:
      contentType === 'ContentfulNews'
        ? 'NEWS'
        : props?.category?.title || props.type,
    slug: isNewsOrEvent ? props.parentPath : props?.category?.slug,
  }
  const date = props?.publicationDate || props?.createdAt

  const authors = renderAuthor({
    authors: props?.authors,
    bylineHtml: props?.bylineHtml,
    associatedProfessionals: props?.associatedProfessionals,
  })

  title = parseHTMLSpecialChars(title)
  const isGrowthPyramidPage =
    props?.['contentful_id'] === '8rHDuF0GyvQ61Qavi837q' || // add pyramid if Growth in a New Era page
    props?.preview?.sys?.id === '8rHDuF0GyvQ61Qavi837q'

  const shouldShowCustomEyebrow =
    props?.category?.title === 'Practice Area Articles' &&
    props?.showCustomEyebrow === true &&
    props?.customEyebrow

  return isGrowthPyramidPage ? (
    <>
      <H3
        color="gold"
        letterSpacing="1.71px"
        lineHeight="26px"
        marginBottom={10}
        className={`qtph-insightspge-insightstypetitle-txt ${!isNewsOrEvent &&
          'hover:underline'}`}
      >
        {categoryData.title &&
          renderEyebrow(props, categoryData, isNewsOrEvent, contentType)}
      </H3>
      <InsightsH1
        marginBottom={40}
        color="navy"
        smallerText="2.5"
        lineHeight="40px"
      >
        {title}
      </InsightsH1>
      <SocialMedia title={title} displayShare />
      <Html
        contentHtml={
          props?.preview ? props?.preview?.bylineHtml : props?.bylineHtml
        }
      />
    </>
  ) : (
    // normal page
    <>
      <H3
        color="gold"
        letterSpacing="1.71px"
        lineHeight="26px"
        marginBottom={10}
        className={`qtph-insightspge-insightstypetitle-txt ${!isNewsOrEvent &&
          'hover:underline'}`}
      >
        {categoryData.title &&
          renderEyebrow(props, categoryData, isNewsOrEvent, contentType)}
      </H3>
      <InsightsH1
        marginBottom={40}
        color="navy"
        smallerText="2.5"
        lineHeight="40px"
      >
        {title}
      </InsightsH1>
      <ArticleDetails
        contentType={contentType}
        date={date}
        authors={authors}
        category={categoryData.title}
        useByline={props?.useByline}
      />
      <SocialMedia title={title} displayShare />
    </>
  )
}

export default ArticleHeader
